import { FabricObject, Rect } from 'fabric';

import { MapObject } from './map-object';
import { Point } from '@ng-cloud/badger-core/models/interfaces/point';
import { Facing } from '../../models/facing';

export class FacingObject extends MapObject {
  static DEFAULT_STROKE_WIDTH = 2;

  strokeWidth = FacingObject.DEFAULT_STROKE_WIDTH;

  defaultOptions: any = {
    selectable: false,
    evented: false,
    lockScalingFlip: true,
    borderColor: 'white',
    borderScaleFactor: 4.0,
    padding: 8,
    fill: 'transparent',
    stroke: 'orange',
    opacity: 1.0,
    lockMovementX: true,
    lockMovementY: true,
    hasControls: false,
    hoverCursor: 'pointer'
  };

  rect: Rect;

  constructor(public facing: Facing, private points: Point[], config?: any) {
    super(config);

    const scaleFactor = config.scaleFactor ? config.scaleFactor : 1;
    this.strokeWidth = FacingObject.DEFAULT_STROKE_WIDTH * scaleFactor;
    Object.assign(this.defaultOptions, { strokeWidth: this.strokeWidth });
  }

  protected build(): FabricObject {
    this.rect = new Rect(this.getOptions());
    this.rect.set({ data: this.facing });
    return this.rect;
  }

  protected getInstanceOptions(): any {
    return {
      width: Math.abs(this.points[0].x - this.points[1].x) - this.strokeWidth,
      height: Math.abs(this.points[0].y - this.points[2].y) - this.strokeWidth,
      left: this.points[0].x,
      top: this.points[2].y
    };
  }
}
